import { useEffect, useState } from "react";

import { FormattedMessage } from "react-intl";
import { Collapse } from "@mui/material";
import Panel from "../../../ui/Panel/Panel";
import Table from "../../../components/Table/Table";

import {
  IReportStepOneProps,
  TypeFilter,
  REPORT_FORM_FILTER,
} from "./module/constants";
import messages from "./module/messages";
import filterMessages from "../../../translations/filterMessages";
import { REPORT_URLS } from "../module/constants";

import { selectReports, selectReportsLoader } from "../module/selectors";
import {
  modifySelectedReport,
  reportsRequest,
  reportResetState,
} from "../module/actions";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import FilterTable from "../../../components/FilterTable/FilterTable";

import { isEmpty } from "ramda";
import { push } from "connected-react-router";
import OutlinedButton from "../../../ui/OutlinedButton/OutlinedButton";

import classes from "./ReportStepOne.module.scss";
import { ROUTES } from "../../../module/constants";
import {
  ISectionType,
  ITableType,
} from "../../../common/TablesConfiguration/tcConstants";
const form = REPORT_FORM_FILTER;

const ReportStepOne = (props: IReportStepOneProps) => {
  const {
    reports,
    reportsLoader,
    reportsRequest,
    modifySelectedReport,
    goBack,
    resetReportState,
  } = props;

  const [reportDataSource, setReportDataSource] = useState<any>([]);

  const [filter, setFilter] = useState<any>([]);

  const onSubmit: any = (values: any = {}) => {
    const { advancedSearchFilter, allFilter = "", ...rest } = values;
    let valueFilter: any[] = [];
    if (values && isEmpty(values)) return setFilter([]);

    if (advancedSearchFilter) {
      if (!isEmpty(rest)) {
        Object.keys(rest).forEach((element: any) => {
          valueFilter.push({
            id: TypeFilter[element as keyof typeof TypeFilter],
            value: rest[element],
            operation: "AND",
          });
        });
      }
    } else {
      valueFilter = [
        { id: "id", value: allFilter, operation: "OR" },
        { id: "name", value: allFilter, operation: "OR" },
        { id: "description", value: allFilter, operation: "OR" },
      ];
    }
    setFilter(valueFilter);
  };

  useEffect(() => {
    resetReportState();
    reportsRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (reports) {
      let tempReportDataSource: { id: any; name: any; description: any }[] = [];
      reports.forEach((report) => {
        let ObjectTemp = {
          id: report.report.id,
          name: report.report.name,
          description: report.report.description,
        };
        tempReportDataSource.push(ObjectTemp);
      });
      setReportDataSource(tempReportDataSource);
    }
  }, [reports]);

  return (
    <div>
      <div className={classes["cta_wrapper"]}>
        <OutlinedButton onClick={goBack}>
          <FormattedMessage {...messages.CTA_BACK} />
        </OutlinedButton>
      </div>
      <Collapse in={true}>
        <Panel
          title={<FormattedMessage {...messages.PanelTitle} />}
          loader={reportsLoader}
        >
          {reports && reports.length === 0 ? (
            <div className={classes["text-no-users"]}>
              <FormattedMessage {...messages.noReportFound} />
            </div>
          ) : (
            <></>
          )}
          {reports && reports.length > 0 ? (
            <>
              <FilterTable
                messages={{ ...filterMessages, ...messages }}
                formProps={form}
                onSubmitProps={(val: any) => onSubmit(val)}
                advancedFilter={true}
                isAccordion={true}
                sectionType={ISectionType.REPORTS}
                tableType={ITableType.REPORTS_TABLE}
                typeFilter={TypeFilter}
                simpleFilterFields={["id", "name", "description"]}
              />
              <Table
                filterProps={filter}
                dataSource={reportDataSource}
                rowsChangeable={false}
                showDetail={true}
                onDetailClick={(e: any) => modifySelectedReport(e)}
                detailURL={REPORT_URLS.REPORT_DETAIL}
                sectionType={ISectionType.REPORTS}
                tableType={ITableType.REPORTS_TABLE}
              />
            </>
          ) : (
            <></>
          )}
        </Panel>
      </Collapse>
      <div className={classes["cta_wrapper"]}>
        <OutlinedButton onClick={goBack}>
          <FormattedMessage {...messages.CTA_BACK} />
        </OutlinedButton>
      </div>
    </div>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    reports: selectReports,
    reportsLoader: selectReportsLoader,
  });

const mapDispatchToProps: any = {
  reportsRequest: () => reportsRequest(),
  modifySelectedReport: (report: {}) => modifySelectedReport(report),
  resetState: () => reportResetState(),
  goBack: () => push(ROUTES.WELCOME),
  resetReportState: () => reportResetState(),
};

const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(ReportStepOne);
